'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OnFileChanged = function () {
  function OnFileChanged($parse) {
    'ngInject';

    _classCallCheck(this, OnFileChanged);

    this.restrict = 'A';
    Object.assign(this, { $parse: $parse });
  }

  _createClass(OnFileChanged, [{
    key: 'link',
    value: function link($scope, element, attrs) {
      var attrHandler = this.$parse(attrs.onFileChanged);

      var handler = function handler(e) {
        $scope.$apply(function () {
          attrHandler($scope, { $event: e, files: e.target.files });
        });
      };

      element[0].addEventListener('change', handler, false);
    }
  }], [{
    key: 'directiveFactory',
    value: function directiveFactory($parse) {
      'ngInject';

      return new OnFileChanged($parse);
    }
  }]);

  return OnFileChanged;
}();

exports.default = OnFileChanged;


// WEBPACK FOOTER //
// ./common/directives/on-file-changed.js